import { getGoogleAnalyticsClientIds } from './tracking/googleAnalytics';
import api from './callApi';
import adblockDetect from 'adblock-detect';

export const adBlockCheck = new Promise((resolve, reject) => {
    if (typeof window !== 'undefined') {
        adblockDetect(resolve);
    }
});

export const trackAdBlock = (widgetData, page) => {
    const data = {
        type: 'NotDisplayed',
        articleId: widgetData.articleId,
        articleUrlTracking: page.articleUrlTracking,
        widgetId: widgetData.widgetId,
        publisherId: widgetData.publisherId,
        publishedDate: widgetData.publishedDate,
        widgetType: widgetData.widgetType,
        widgetEmbedType: page.embedType,
        sponsored: widgetData.isSponsored,
        ...getGoogleAnalyticsClientIds(),
        clientIdCustom: widgetData.clientIdCustom,
        actions: []
    };
    return api.post('Widget/RecordActivity', data);
};
